document.addEventListener('DOMContentLoaded', () => {
	const getForms = setInterval(() => {
		const forms = document.querySelectorAll('shopify-forms-embed');
		if (forms.length > 0) {
			clearInterval(getForms);
			handleShopifyFormsRtl(forms);
		}
	}, 100);

	function handleShopifyFormsRtl(forms) {
		forms.forEach((form) => {
			const shadowRoot = form.shadowRoot;
			if (shadowRoot) {
				console.log('shadowRoot', shadowRoot);
				const labels = shadowRoot.querySelectorAll('form label');

				labels.forEach((label) => {
					label.style.left = 'unset';
					label.style.right = '15px';
				});
			}
		});
	}
});
